import { getStaticAssetUrl } from '@/app/lib/utils/static-asset-url';
import gsap from 'gsap';

export default function initAnimation(
    root: HTMLElement,
    bgCanvas: HTMLCanvasElement,
    options?: {
        onReady?: () => void;
    },
) {
    const frameCount = 360;
    bgCanvas.width = root.clientWidth;
    bgCanvas.height = root.clientHeight;
    const context = bgCanvas.getContext('2d')!;
    const currentFrame = (index: number) =>
        `${getStaticAssetUrl(
            `/terra1/${index.toString().padStart(5, '0')}.jpg`,
        )}`;

    const images: HTMLImageElement[] = [];

    const bgs = {
        frame: 0,
    };
    let hasAnnouncedReady = false;

    for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
        images.push(img);
    }

    const tween = gsap.to(bgs, {
        frame: frameCount - 1,
        snap: 'frame',
        ease: 'none',
        scrub: true,
        repeat: -1,
        duration: 12,
        onUpdate: render, // use animation onUpdate instead of scrollTrigger's onUpdate
    });

    images[0].onload = render;
    images[0].onerror = () => {
        if (!hasAnnouncedReady) {
            hasAnnouncedReady = true;
            options?.onReady?.();
        }
    };

    function render() {
        if (bgCanvas.width != root.clientWidth) {
            bgCanvas.width = root.clientWidth;
            bgCanvas.height = root.clientHeight;
        }

        const img = images[bgs.frame];
        const canvasRatio = bgCanvas.width / bgCanvas.height;
        const imgRatio = img.naturalWidth / img.naturalHeight;
        let drawWidth, drawHeight, sx, sy, sWidth, sHeight;

        if (imgRatio > canvasRatio) {
            // 图片比画布更宽
            drawHeight = bgCanvas.height;
            drawWidth = bgCanvas.height * imgRatio;
            sWidth = img.naturalHeight * canvasRatio;
            sHeight = img.naturalHeight;
            sx = (img.naturalWidth - sWidth) / 2;
            sy = 0;
        } else {
            // 图片比画布更高
            drawWidth = bgCanvas.width;
            drawHeight = bgCanvas.width / imgRatio;
            sWidth = img.naturalWidth;
            sHeight = img.naturalWidth / canvasRatio;
            sx = 0;
            sy = (img.naturalHeight - sHeight) / 2;
        }

        context.clearRect(0, 0, bgCanvas.width, bgCanvas.height);
        context.drawImage(
            img,
            sx,
            sy,
            sWidth,
            sHeight,
            0,
            0,
            bgCanvas.width,
            bgCanvas.height,
        );

        if (!hasAnnouncedReady) {
            hasAnnouncedReady = true;
            options?.onReady?.();
        }
    }

    const handleResize = () => {
        bgCanvas.width = root.clientWidth;
        bgCanvas.height = root.clientHeight;
        render(); // 确保在窗口大小改变时重新渲染画布
    };

    window.addEventListener('resize', handleResize);

    return () => {
        tween.kill();
        window.removeEventListener('resize', handleResize);
    };
}
